import Table, { TableProps } from './table';

export type { TableProps };
export default Table;
